import React from "react"

import {
  useAccount,
  useSchedule,
  Viewer,
} from "../../../contexts"
import { useViewers } from "../../../hooks"
import { Message } from "../../../hooks/useMessages"
import { useUserActionStore } from "../../../stores/streamerStore"
import {useSnackbar} from "notistack";
import {GROUP} from "../../../config";

const ViewerControlMenu = ({
  message,
  children,
}: {
  message: Message
  children: React.ReactNode
}) => {
  const { userAction: action, setUserAction: setAction, closeUserAction: closeAction } = useUserActionStore()

  const { enqueueSnackbar } = useSnackbar();
  const { account } = useAccount()
  const { schedule } = useSchedule()
  const { viewers } = useViewers()

  const viewer = viewers.find((viewer) => viewer.nickname === message.nickname)
  const isStreamer = GROUP.STREAMER.includes(account?.viewer?.role as string)

  const [isMouseEnter, setIsMouseEnter] = React.useState(false)

  const handleActionControlViewer = () => {
    if (!viewer) {
      enqueueSnackbar(`현재 시청자 목록에 없는 유저입니다.`, { variant: "info",  anchorOrigin: { vertical: "top", horizontal: "right" } });
      closeAction()
      return
    }
    setAction({
      isActive: true,
      props: {
        viewer,
        account,
        schedule,
      },
    })
  }

  if (!isStreamer) {
    return <>{children}</>
  }

  return (
    <div
      onClick={handleActionControlViewer}
      style={{
        display: "inline-block",
        borderBottom: `${isMouseEnter ? "1px solid #000" : "1px solid transparent"} `,
        cursor: "pointer",
      }}
      onMouseEnter={() => setIsMouseEnter(true)}
      onMouseLeave={() => setIsMouseEnter(false)}
    >
      {children}
    </div>
  )
}

export default ViewerControlMenu
